import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as youtubeModal from '../../actions/youtube-modal';

@Component({
  selector: 'edge-support-content',
  templateUrl: './support-content.component.html',
  styleUrls: ['./support-content.component.scss']
})
export class SupportContentComponent {
  @Input() videos: Array<any>;
  @Input() header: string = '';
  @Input() sport: string = '';

  constructor(private store: Store<fromRoot.State>) {}

  showModal(id: string, show?: boolean): void {
    this.store.dispatch(youtubeModal.ChangeVideoIdAction(id));
  }
}
